import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Head_5 } from '../Typography';
import styled from 'styled-components';

const ContactItem = ({ icon, content }) => {
  return (
    <ContactItemContainer>
      <ContactItemIconBox>
        <ContactItemIcon>
          <FontAwesomeIcon icon={icon} />
        </ContactItemIcon>
      </ContactItemIconBox>
      <Head_5>{content}</Head_5>
    </ContactItemContainer>
  );
};
const ContactItemContainer = styled.div`
  width: 40rem;
  display: flex;
  align-items: center;
`;
const ContactItemIcon = styled.div`
  width: 7rem;
  height: 6rem;
  background: #afafaf;
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin: 1rem -2rem;
`;
const ContactItemIconBox = styled.div`
  width: 7rem;
  height: 6rem;
  border: 3.5px dashed #4e6e29;
  border-radius: 4px;
  margin-bottom: 4rem;
`;
export default ContactItem;
